<div class="content">
  <mat-dialog-actions>
    <div class="preview-image-non-scrollable-container">
      @for (image of images.slice().reverse(); track image; let i = $index) {
        <div>
          <img
            [src]="image"
            [ngClass]="{ 'red-border': show_border && i === 0 }"
            alt="Photo"
            class="preview-image"
          />
        </div>
      }
    </div>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </mat-dialog-actions>

  <mat-dialog-content>
    <div class="video-container">
      <video #video id="video" autoplay muted playsinline></video>
    </div>
  </mat-dialog-content>

  @if (stream) {
    <mat-dialog-actions>
      <button
        mat-icon-button
        (click)="save()"
        class="fixed-size"
        aria-label="photo-button"
      >
        <mat-icon>camera_alt</mat-icon>
      </button>
      <span class="fixed-size">{{ getTotalZoom().toFixed(1) }}x</span>
      <div class="grow-size">
        <mat-slider min="0" [max]="Math.log(maxZoomSlider)" step="0.01">
          <input
            matSliderThumb
            id="zoom-slider-input"
            aria-label="Zoom"
            [(ngModel)]="sliderValue"
            (valueChange)="applyZoom(stream)"
          />
        </mat-slider>
      </div>
    </mat-dialog-actions>
  }
</div>
